import Accordion from 'vt-frontend-engine/app/scripts/basics/accordion';
import debounce from 'vt-frontend-engine/app/scripts/principles/performance/debounce';
import matchViewport from 'vt-frontend-engine/app/scripts/principles/responsive/match-viewport';

(function () {

  var
  tutorDropdowns = [],
  $tutorDropdowns = $('.js-tutor-nav-dropdown'),
  innerIsSetup = false,
  subjectAccordions = [],
  $innerHeadings = $tutorDropdowns.find('.js-accordion-header'),

  init = function() {
    // Set up the tutor dropdown buttons/panels
    $.each($tutorDropdowns, function(index, tutorDropdown) {
      tutorDropdowns[index] = new Accordion($(tutorDropdown));
    });

    // Then set up the inner accordions
    initInnerAccordions();
  },

  // If anything but a dropdown element is clicked, any open tutor dropdown will close
  closeDropdownOnOffClick = function() {
    $('body').on('click touchstart', function(e) {
      $.each(tutorDropdowns, function(index, constructor) {
        var constructorElement = $(constructor.$accordion)[0];

        // Close the dropdown if you click anything but the dropdown elements
        if (!constructorElement.contains(e.target)) {
          var $tab = $(constructor.$tab)[0],
          state = 'close';
          constructor.setPanelState(state, $tab);
        }
      });
    });
  },

  // This is run on load and when the window is resized
  // It decides if the inner accordions should be accordions or not
  initInnerAccordions = function() {
    if (matchViewport('width-xxl')) {
      teardownInnerAccordions();
    } else {
      setupInnerAccordions();
    }
  },

  // Set up inner accordions if they haven't already been created
  setupInnerAccordions = function() {
    if (!innerIsSetup) {
      innerIsSetup = true;

      $.each($innerHeadings, function (index, value) {
        subjectAccordions[index] = new Accordion($(value));
      });

      $innerHeadings.on('click', function(event) {
        event.preventDefault();
      });
    }
  },

  // Remove inner accordions if they exist
  teardownInnerAccordions = function() {
    if (innerIsSetup) {
      innerIsSetup = false;

      $.each(subjectAccordions, function(index, value) {
        value.teardown();
      });
    }
  };

  init();
  $(window).on('resize', debounce(initInnerAccordions, 250));
  // Collapse dropdown when the focus is no longer on it
  closeDropdownOnOffClick();
}());
